import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Grid, Theme, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IconStates, IconStateType } from '../../../types/type';

export default function ConfirmationHeader(props: IconStates) {
  const theme: Theme = useTheme();
  const iconStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    p: '1rem',
  };

  let icon = <div></div>;
  switch (props.state) {
    case IconStateType.SUCCESS_STATE:
      icon = <CheckCircleIcon sx={theme.custom.styles.confirmationSuccessIcon}></CheckCircleIcon>;
      break;
    case IconStateType.FAIL_STATE:
      icon = <ErrorIcon sx={theme.custom.styles.confirmationErrorIcon}></ErrorIcon>;
      break;
    case IconStateType.WARNING_STATE:
      icon = <ErrorIcon sx={theme.custom.styles.confirmationWarningIcon}></ErrorIcon>;
      break;

    default:
      break;
  }

  const headerComponentAsRow = (
    <Grid item container>
      {props.state !== IconStateType.NONE && (
        <Grid item container sx={iconStyle} xs={2} md={1}>
          <Box sx={iconStyle}>{icon}</Box>
        </Grid>
      )}

      <Grid container item xs={10} md={10} sx={{ alignContent: 'center' }}>
        <Grid item>
          <Typography sx={theme.custom.styles.titleType2}>{props.headerContent}</Typography>
        </Grid>
        {props.subHeaderContent && (
          <Grid item container xs={12}>
            <Typography sx={{ ...theme.custom.styles.titleType3, py: '1rem' }}>{props.subHeaderContent}</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );

  const headerComponentAsColumn = (
    <Grid item container>
      {props.state !== IconStateType.NONE && (
        <Grid item container sx={iconStyle} xs={12} md={1}>
          <Box sx={iconStyle}>{icon}</Box>
        </Grid>
      )}

      <Grid container item xs={12} md={11}>
        <Grid item>
          <Typography sx={theme.custom.styles.titleType2}>{props.headerContent}</Typography>
        </Grid>
        {props.subHeaderContent && (
          <Grid item container xs={12}>
            <Typography sx={{ ...theme.custom.styles.titleType3, py: '1rem' }}>{props.subHeaderContent}</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Box sx={{ width: '100%', display: 'flex' }}>{isDesktop ? headerComponentAsRow : headerComponentAsColumn}</Box>
  );
}
